import React from 'react'
import { BANKING_BOTTOM_CONTENT, CERTIFICATION_COURSE_PAGE_5, CERTIFICATION_DETAILS_PAGE_5, CERTIFICATION_HERO_PAGE_5 } from '../../../utils/constants'
import CourseCard from '../../../reusable/Course-card'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import { CERTIFICATION_ACCORDIAN_5 } from '../../../utils/courseConifg'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'

const CertificationPage_5 = () => {
  return (
    <div className='outlet-render'>
    <CourseAsideHero  {...CERTIFICATION_HERO_PAGE_5}/>
     <CoursesAside {...CERTIFICATION_COURSE_PAGE_5}/>
     <CourseCard {...CERTIFICATION_DETAILS_PAGE_5}/>
     <Accordian {...CERTIFICATION_ACCORDIAN_5}/>
     <PageDesc {...BANKING_BOTTOM_CONTENT}/>
   </div>
  )
}

export default CertificationPage_5